<template>
    <BaseDialog
        :showDialog="showDialog"
        headline="lang_GENERIC_CAPTION_MANAGE_TAGS"
        :close="closeDialog"
        maxCardHeight="500"
        :alvqa="alvqa"
    >
        <template v-slot:dialogActions>
            <v-container fluid>
                <v-row>
                    <v-col>
                        <v-text-field
                            v-model="addTag"
                            :label="$t('lang_GENERAL_CAPTION_ADD_TAG')"
                            hide-details
                            :alvqa="alvqa + '-textfield-add-tag'"
                        ></v-text-field>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col>
                        <v-text-field
                            v-model="removeTag"
                            :label="$t('lang_GENERAL_CAPTION_REMOVE_TAG')"
                            hide-details
                            :alvqa="alvqa + '-textfield-remove-tag'"
                        ></v-text-field>
                    </v-col>
                </v-row>
                <v-row>
                    <v-spacer></v-spacer>
                    <v-col class="text-right">
                        <BaseButton 
                            @click="apply"
                            label="lang_GENERIC_CAPTION_APPLY"
                            :alvqa="alvqa+'-button-apply'"
                        />
                    </v-col>
                </v-row>
            </v-container>
        </template>
    </BaseDialog>
</template>

<script>
import BaseDialog from '@/components/_base/BaseDialog'
import BaseButton from '@/components/_buttons/BaseButton'

export default {
    name: "ManageTagsDialog",
    props: {
        context: String, // needed to get the context of the selected items, e.g. 'selectedWorks'
        dir: String, // needed for api call, to know the context, e.g. 'publishing/works'
        idAttributeName: String // needed for payload, e.g. 'workIds' or 'releaseIds'
    },
    data() {
        return {
            valid: true,
            alvqa: 'manage-tags-dialog'
        }
    },
    components: {
        BaseDialog,
        BaseButton
    },
    computed: {
        showDialog: {
            get() { return this.$store.getters.getShowManageTagsDialog },
            set(show) { this.$store.commit('setShowManageTagsDialog', show) }
        },
        addTag: {
            get() { return this.$store.getters.getAddTag },
            set(tag) { this.$store.commit('setAddTag', tag.replace(/\s/g, '')) }
        },
        removeTag: {
            get() { return this.$store.getters.getRemoveTag },
            set(tag) { this.$store.commit('setRemoveTag', tag.replace(/\s/g, '')) }
        },
    },
    methods: {
        closeDialog() {
            this.showDialog = false
            this.addTag = ''
            this.removeTag = ''
        },
        apply() {
            this.$store.dispatch('manageTags', {dir: this.dir, context: this.context, ids: this.idAttributeName })
            this.closeDialog()
        }
    }
}
</script>